<div class="beleglos-locked-wrapper">
  <jf-icon
    [name]="'file'"
    [iconColor]="'#9D9D9D'"
    [size]="70"
    [strokeWidth]="0.3"
  ></jf-icon>

  <p class="title">Kein Beleg gewählt.</p>

  <p class="description">Hierzu hast du keinen Beleg ausgewählt, <br />leider ist dies jetzt nicht mehr möglich.</p>
</div>
